export const WS302List: any[] = [
  {
    deviceName: 'WS-2648',
    payload: null
  },
  {
    deviceName: 'WS-3164',
    payload: null
  },
  {
    deviceName: 'WS-8588',
    payload: null
  },
  {
    deviceName: 'WS-8654',
    payload: null
  },
  {
    deviceName: 'WS-8709',
    payload: null
  },
  {
    deviceName: 'WS-8852',
    payload: null
  },
  {
    deviceName: 'WS-9199',
    payload: null
  },
  {
    deviceName: 'WS-9247',
    payload: null
  }
];

